import axios from 'axios';
import store from '../store';
import MessageHandler from '../messageHandler';
import ErrorMessageService from './ErrorMessageService';
import { __ } from '../helpers';

export default class ApiService {
    constructor() {
        this.initAxios();
        this.errorMessageService = new ErrorMessageService();
    }

    get baseUrl() {
        return process.env.MIX_BASE_URL;
    }

    convertDataToFormData(data, method = null) {
        const formData = new FormData();

        if (method) {
            formData.append('_method', method);
        }

        for (let property in data) {
            if (data.hasOwnProperty(property)) {
                formData.append(property, data[property]);
            }
        }

        return formData;
    }

    errorHandler(error) {
        switch (error.status) {
            case 401:
                store.dispatch('reLogin');
                break;
            case 422:
                store.state.alerts.push(
                    new MessageHandler(
                        this.errorMessageService.getErrorMessage(
                            error.data.errors
                        ),
                        __('Error.'),
                        'error'
                    )
                );
                break;
            default:
                store.state.alerts.push(
                    new MessageHandler(
                        __('An error occurred. Please check you connection.'),
                        __('Error.'),
                        'error'
                    )
                );
        }
    }

    delete(slug) {
        return new Promise((resolve, reject) => {
            axios
                .delete('api/' + slug)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    this.errorHandler(error.response);

                    reject(error.response);
                });
        });
    }

    get(slug, config = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(this.baseUrl + slug, config)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    this.errorHandler(error.response);

                    reject(error.response);
                });
        });
    }

    initAxios() {
        axios.interceptors.request.use(request => {
            const token = store.state.userToken;
            request.headers['Authorization'] = 'Bearer ' + token;

            return request;
        });
    }

    post(slug, data) {
        return new Promise((resolve, reject) => {
            axios
                .post(this.baseUrl + slug, data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    this.errorHandler(error.response);

                    reject(error.response);
                });
        });
    }

    put(slug, data) {
        return new Promise((resolve, reject) => {
            axios
                .put(this.baseUrl + slug, data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    this.errorHandler(error.response);

                    reject(error.response);
                });
        });
    }
}
